// Missing legacy angles have no label; never substitute a fabricated angle.
export const formatRebarAngle = (angle: number | string | null | undefined): string | null =>
  angle == null || angle === "" || !Number.isFinite(Number(angle)) ? null : String(angle);

export const getRebarRadiusError = (radius: number | null | undefined, sideLength: number,
  roundingEnabled: boolean): "min" | "max" | null => {
  if (!roundingEnabled && (radius == null || Number(radius) === 0)) return null;
  if (Number(radius) > Number(sideLength) / 2) return "max";
  if (radius == null || Number(radius) <= 0) return "min";
  return null;
};
